import { fullNameValidation } from './nameOnCardValidation';
import {
  phoneValidation,
  street1Validation,
  cityValidation,
  stateValidation,
  postalCodeValidation,
} from './addressValidations';

const ShippingAddressFormValidations = values => ({
  ...fullNameValidation(values.fullName),
  ...phoneValidation(values.phoneNumber),
  ...street1Validation(values.street1),
  ...cityValidation(values.city),
  ...stateValidation(values.state),
  ...postalCodeValidation(values.postalCode),
});

export default ShippingAddressFormValidations;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/shippingAddressFormValidation.js